import { useAuth } from '@/hooks/useAuth';
import AdminHeader from './components/AdminHeader';
import ContactsTable from './components/ContactsTable';

export default function AdminPage() {
  const { user } = useAuth();

  if (!user) return null;

  return (
    <div className="min-h-screen flex flex-col" style={{ background: '#F8F9FD' }}>
      <AdminHeader user={user} />

      <main className="flex-1 px-6 md:px-10 py-8 max-w-7xl w-full mx-auto">
        {/* Stats row */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
          {[
            { icon: 'ri-mail-line', label: 'Mensagens', desc: 'Total recebido', color: '#C9A24A' },
            { icon: 'ri-global-line', label: 'Site', desc: 'LC Advogados', color: '#0B2F5B' },
            { icon: 'ri-shield-check-line', label: 'Seguro', desc: 'Acesso autenticado', color: '#16a34a' },
          ].map((s, i) => (
            <div
              key={i}
              className="rounded-xl px-5 py-4 flex items-center gap-4"
              style={{ background: '#FFFFFF', border: '1px solid rgba(11,47,91,0.08)' }}
            >
              <div
                className="w-10 h-10 rounded-xl flex items-center justify-center shrink-0"
                style={{ background: `${s.color}15` }}
              >
                <i className={`${s.icon} text-lg`} style={{ color: s.color }} />
              </div>
              <div>
                <p className="font-bold text-sm" style={{ color: '#0B2F5B' }}>{s.label}</p>
                <p className="text-xs" style={{ color: '#1A1A1A', opacity: 0.45 }}>{s.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Contacts table */}
        <div
          className="rounded-2xl p-6 md:p-8"
          style={{ background: '#FFFFFF', border: '1px solid rgba(11,47,91,0.08)' }}
        >
          <ContactsTable />
        </div>
      </main>
    </div>
  );
}
